export const GLOBAL_ROUTE_PREFIX =
    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix";

const proxy = {
    // ===========================================
    // MASTER DATA ENTITIES
    // ===========================================
    Customer: `${GLOBAL_ROUTE_PREFIX}/master_data/customers/:id`,
    Customers: `${GLOBAL_ROUTE_PREFIX}/master_data/customers/:id`,
    Account: `${GLOBAL_ROUTE_PREFIX}/master_data/accounts/:id`,
    Product: `${GLOBAL_ROUTE_PREFIX}/master_data/products/:id`,
    Products: `${GLOBAL_ROUTE_PREFIX}/master_data/products/:id`,
    GeneralLedger: `${GLOBAL_ROUTE_PREFIX}/master_data/general_ledgers/:id`,
    TaxTableEntry: `${GLOBAL_ROUTE_PREFIX}/master_data/tax_table_entries/:id`,
    TaxTableEntries: `${GLOBAL_ROUTE_PREFIX}/master_data/tax_table_entries/:id`,
    TaxTableEntryDetail: `${GLOBAL_ROUTE_PREFIX}/master_data/tax_table_entry_details/:id`,
    TaxTableEntryDetails: `${GLOBAL_ROUTE_PREFIX}/master_data/tax_table_entry_details/:id`,
    UomTableEntry: `${GLOBAL_ROUTE_PREFIX}/master_data/uom_table_entries/:id`,
    UomTableEntries: `${GLOBAL_ROUTE_PREFIX}/master_data/uom_table_entries/:id`,
    MovementType: `${GLOBAL_ROUTE_PREFIX}/master_data/movement_types/:id`,
    MovementTypes: `${GLOBAL_ROUTE_PREFIX}/master_data/movement_types/:id`,
    MovementTypeTable: `${GLOBAL_ROUTE_PREFIX}/master_data/movement_type_table/:id`,
    GeneralLedgerAccount: `${GLOBAL_ROUTE_PREFIX}/master_data/general_ledger_accounts/:id`,
    GeneralLedgerAccounts: `${GLOBAL_ROUTE_PREFIX}/master_data/general_ledger_accounts/:id`,
    Owner: `${GLOBAL_ROUTE_PREFIX}/master_data/owners/:id`,
    Owners: `${GLOBAL_ROUTE_PREFIX}/master_data/owners/:id`,
    AnalysisTypeTableEntry: `${GLOBAL_ROUTE_PREFIX}/master_data/analysis_type_table_entries/:id`,
    AnalysisTypeTableEntries: `${GLOBAL_ROUTE_PREFIX}/master_data/analysis_type_table_entries/:id`,
    AnalysisTypeTable: `${GLOBAL_ROUTE_PREFIX}/master_data/analysis_type_table/:id`,
    AnalysisTypeTables: `${GLOBAL_ROUTE_PREFIX}/master_data/analysis_type_table/:id`,
    Asset: `${GLOBAL_ROUTE_PREFIX}/master_data/assets/:id`,
    Assets: `${GLOBAL_ROUTE_PREFIX}/master_data/assets/:id`,
    Header: `${GLOBAL_ROUTE_PREFIX}/master_data/headers/:id`,
    Headers: `${GLOBAL_ROUTE_PREFIX}/master_data/headers/:id`,
    Supplier: `${GLOBAL_ROUTE_PREFIX}/master_data/suppliers/:id`,
    Suppliers: `${GLOBAL_ROUTE_PREFIX}/master_data/suppliers/:id`,
    PhysicalStock: `${GLOBAL_ROUTE_PREFIX}/master_data/physical_stocks/:id`,
    PhysicalStocks: `${GLOBAL_ROUTE_PREFIX}/master_data/physical_stocks/:id`,
    Journal: `${GLOBAL_ROUTE_PREFIX}/master_data/journals/:id`,
    Journals: `${GLOBAL_ROUTE_PREFIX}/master_data/journals/:id`,
    UOMTable: `${GLOBAL_ROUTE_PREFIX}/master_data/UOM_table/:id`,
    UOMTables: `${GLOBAL_ROUTE_PREFIX}/master_data/UOM_table/:id`,
    ChartOfAccounts: `${GLOBAL_ROUTE_PREFIX}/master_data/chart_of_accounts/:id`,
    Employee: `${GLOBAL_ROUTE_PREFIX}/master_data/employee/:id`,
    Employees: `${GLOBAL_ROUTE_PREFIX}/master_data/employee/:id`,
    HeadersModelo7: `${GLOBAL_ROUTE_PREFIX}/master_data/headers_modelo7/:id`,
    // ===========================================
    // TRANSACTIONAL DATA ENTITIES
    // ===========================================
    Transaction: `${GLOBAL_ROUTE_PREFIX}/transactional_data/transactions/:id`,
    Transactions: `${GLOBAL_ROUTE_PREFIX}/transactional_data/transactions/:id`,
    Invoice: `${GLOBAL_ROUTE_PREFIX}/transactional_data/sales_invoices/:id`,
    SalesInvoices: `${GLOBAL_ROUTE_PREFIX}/transactional_data/sales_invoices/:id`,
    PurchaseInvoice: `${GLOBAL_ROUTE_PREFIX}/transactional_data/purchase_invoices/:id`,
    PurchasesInvoices: `${GLOBAL_ROUTE_PREFIX}/transactional_data/purchase_invoices/:id`,
    StockMovement: `${GLOBAL_ROUTE_PREFIX}/transactional_data/stock_movements/:id`,
    StockMovements: `${GLOBAL_ROUTE_PREFIX}/transactional_data/stock_movements/:id`,
    WorkDocument: `${GLOBAL_ROUTE_PREFIX}/transactional_data/work_documents/:id`,
    WorkDocuments: `${GLOBAL_ROUTE_PREFIX}/transactional_data/work_documents/:id`,
    Payment: `${GLOBAL_ROUTE_PREFIX}/transactional_data/payments/:id`,
    Payments: `${GLOBAL_ROUTE_PREFIX}/transactional_data/payments/:id`,
    AssetTransaction: `${GLOBAL_ROUTE_PREFIX}/transactional_data/asset_transactions/:id`,
    AssetTransactions: `${GLOBAL_ROUTE_PREFIX}/transactional_data/asset_transactions/:id`,
    Withholding: `${GLOBAL_ROUTE_PREFIX}/transactional_data/withholding/:id`,
    WithholdingLines: `${GLOBAL_ROUTE_PREFIX}/transactional_data/withholding/:id`,
    WithholdingTax: `${GLOBAL_ROUTE_PREFIX}/transactional_data/withholding_tax/:id`,
    IncomeTax: `${GLOBAL_ROUTE_PREFIX}/transactional_data/income_tax/:id`,
    AccountLedger: `${GLOBAL_ROUTE_PREFIX}/transactional_data/account_ledger/:id`,
    SupportDocs: `${GLOBAL_ROUTE_PREFIX}/transactional_data/support_docs/:id`,
    AccountsReportLines: `${GLOBAL_ROUTE_PREFIX}/transactional_data/accounts_report_lines/:id`,
    HeaderMapTypeInformation: `${GLOBAL_ROUTE_PREFIX}/transactional_data/header_map_type_information/:id`,
    RemunerationMap: `${GLOBAL_ROUTE_PREFIX}/transactional_data/remuneration_map/:id`,
    TaxReturnCalculation: `${GLOBAL_ROUTE_PREFIX}/transactional_data/tax_return_calculation/:id`,
    TaxReturnSummary: `${GLOBAL_ROUTE_PREFIX}/transactional_data/tax_return_summary/:id`,
    SupplierAnnex: `${GLOBAL_ROUTE_PREFIX}/transactional_data/supplier_annex/:id`,
    SupplierRegAnnex: `${GLOBAL_ROUTE_PREFIX}/transactional_data/supplier_reg_annex/:id`,
    ClientRegAnnex: `${GLOBAL_ROUTE_PREFIX}/transactional_data/client_reg_annex/:id`,
    // ===========================================
    // SPECIAL ROUTES
    // ===========================================
    Rule: `/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/nc_audit/:modulePrefix/rules/:id`,
    AuditNavigation: `/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/nc_audit`,
};

export default proxy;
